import { render, staticRenderFns } from "./goods4.vue?vue&type=template&id=3b5aa0fc&scoped=true"
import script from "./goods4.vue?vue&type=script&lang=js"
export * from "./goods4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5aa0fc",
  null
  
)

export default component.exports